// 组件对象，大写
import panguAutoComplete from './panguAutoComplete.vue'
export default panguAutoComplete
